<template>
  <el-input
    v-model="value"
    :placeholder="placeholder"
    :disabled="disabled"
    :style="customStyle"
    :size="size"
    :clearable="clearable"
    :maxlength="maxlength"
    :minlength="minlength"
    class="NumberPoint"
    @input="onInput"
    @blur="blur"
    @focus="focus"
    @change="change"
    @clear="clear"
  >
    <template slot="prefix">
      <slot name="prefix"></slot>
    </template>
    <template slot="suffix">
      <slot name="suffix"></slot>
    </template>
    <template slot="prepend">
      <slot name="prepend"></slot>
    </template>
    <template slot="append">
      <slot name="append"></slot>
    </template>
  </el-input>
</template>

<script>
export default {
  name: 'NumberPoint',
  props: {
    placeholder: {
      type: String,
      default: '请输入'
    },
    customStyle: {
      type: Object,
      default: () => {}
    },
    decimalPlaces: {
      type: [Number, String],
      default: 2
    },
    disabled: {
      type: Boolean,
      default: false
    },
    size: {
      type: String,
      default: 'default'
    },
    clearable: {
      type: Boolean,
      default: false
    },
    minlength: String,
    maxlength: String
  },
  data() {
    return {
      value: ''
    }
  },
  watch: {
    '$attrs.value': {
      handler(v) {
        this.value = v
      },
      immediate: true
    }
  },
  methods: {
    onInput(v) {
      this.value = this.cleanInput(v, +this.decimalPlaces)
      this.$emit('input', this.value)
    },
    cleanInput(value, decimalPlaces = 2) {
      // 1. 允许数字、负号（仅在开头）、小数点
      let cleanedValue = value.replace(/[^0-9.-]/g, '')

      // 2. 处理多个负号：只保留开头的负号
      if ((cleanedValue.match(/-/g) || []).length > 1) {
        cleanedValue = '-' + cleanedValue.replace(/-/g, '')
      }

      // 3. 如果负号不在开头，移除
      if (cleanedValue.indexOf('-') > 0) {
        cleanedValue = cleanedValue.replace(/-/g, '')
      }

      // 4. 特殊处理：允许单独 "-"（不返回 NaN）
      if (cleanedValue === '-') {
        return '-' // 明确返回 "-" 而不是空字符串
      }

      // 5. 禁止 "-." 开头（返回 "-"）
      if (cleanedValue.startsWith('-.')) {
        return '-'
      }

      // 6. 处理小数点
      const firstDotIndex = cleanedValue.indexOf('.')
      if (firstDotIndex !== -1) {
        const beforeDot = cleanedValue.substring(0, firstDotIndex)
        const afterDot = cleanedValue.substring(firstDotIndex + 1).replace(/\./g, '')
        cleanedValue = beforeDot + '.' + afterDot
      }

      // 7. 限制小数位数
      if (decimalPlaces >= 0 && cleanedValue.includes('.')) {
        const [integerPart, decimalPart] = cleanedValue.split('.')
        if (decimalPart.length > decimalPlaces) {
          cleanedValue = integerPart + '.' + decimalPart.slice(0, decimalPlaces)
        }
      }

      // 8. 如果 decimalPlaces=0，移除小数点
      if (decimalPlaces === 0) {
        cleanedValue = cleanedValue.split('.')[0]
      }

      return Number(cleanedValue) ? Number.parseFloat(cleanedValue) : cleanedValue
    },
    blur(v) {
      this.$emit('blur', v)
    },
    focus(v) {
      this.$emit('focus', v)
    },
    change(v) {
      this.$emit('change', v)
    },
    clear(v) {
      this.$emit('clear', v)
    }
  }
}
</script>
